import React from 'react';
import moment from 'moment';
import TrackVisibility from 'react-on-screen';

import config from '@config';
import store from '@tvguide/store';

import { getOnAirClass, getOnDemandIcon } from '@helpers';

const getHighlight = (programGenre, highlights) => {
  return highlights.find(el => el.mdsGenre === programGenre);
};

const nid = store.getState().ux.nid;
const ChannelColumn = ({
  sid,
  programs,
  displayProgramDetails,
  detailPanelProgramId,
  accessibility,
  highlights,
}) => (
  <TrackVisibility
    offset={config.visibilityTrackingOffset}
    partialVisibility
    throttleInterval={500}
    tag="ul"
    className="tvg-list-view__channel-column"
  >
    {({ isVisible }) =>
      isVisible &&
      programs.map(p => {
        const activeAccessibilities = accessibility.filter(el => el.value);
        let highlighted = true;

        if (activeAccessibilities.length > 0) {
          try {
            highlighted = activeAccessibilities.some(a => {
              return p.events[0].access_services.tv[a.propertyName];
            });
          } catch (e) {
            highlighted = false;
          }
        }
        const isHighlighted = getHighlight(p.genre, highlights);

        return (
          <li
            className={`tvg-list-view__program ${
              highlighted ? '' : 'tvg-list-view__program--hide'
            } ${getOnAirClass(moment(), p.start_time, p.duration)} ${
              detailPanelProgramId === p.program_id ? 'is-active' : ''
            }`}
            key={`listview-${p.uuid}`}
            onClick={() => {
              displayProgramDetails(sid, p.uuid, p.program_id);
            }}
          >
            {isHighlighted && (
              <div
                className="tvg-list-view__program__highlight"
                style={{ backgroundColor: isHighlighted.color }}
              ></div>
            )}
            <span className="tvg-list-view__program__start-time">
              {getOnDemandIcon(moment(), p, nid, sid)}
              {moment(p.start_time).format('H:mma')}
            </span>
            <span
              className="tvg-list-view__program__title"
              dangerouslySetInnerHTML={{ __html: p.main_title }}
            />
          </li>
        );
      })
    }
  </TrackVisibility>
);

export default ChannelColumn;
